import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import Checkboxes from './Checkboxes';

const QuizCheckboxes = (props) => {
  const { entity, customClasses, showOther, ...fieldProps } = props;
  const { t } = useTranslation();
  const title = entity.get('#title');
  const required = entity.get('#required');
  const requiredError = entity.get('#required_error');
  const description = entity.get('#description');
  const placeholder = entity.get('#placeholder');
  const key = entity.get('#webform_key');
  const otherLabel = entity.get('#other__option_label');
  const otherPlaceholder = entity.get('#other__placeholder');
  const layoutOptions = entity.get('#options_display', null);
  const wrapperClassNames = c('QuizCheckboxes', entity.getIn(['#wrapper_attributes', 'class', 0], ''), layoutOptions ? `QuizCheckboxes--${layoutOptions}` : null);
  const elementClassNames = entity.getIn(['#attributes', 'class', 0], '');
  const correctAnswers = entity.get('#answer_value').split(',');
  const explanation = entity.get('#answer_explanation', '');

  let options = entity.get('#options', Immutable.Map());
  if (showOther) {
    options = options.set('__other__', t(['webform.components.checkboxes.other', 'webform.other', 'webform_other'], 'Anders'));
  }

  const descriptions = options.map((option) => {
    if (option.split(' -- ').length > 1) {
      return option.split(' -- ')[1];
    }
    return null;
  });

  options = options.map((option) => {
    if (option.split(' -- ').length > 1) {
      return option.split(' -- ')[0];
    }
    return option;
  });

  function validation(value) {
    let error;
    if (required && value.length === 0) {
      error = requiredError || t(['webform.components.checkboxes.required', 'webform.required', 'webform_required']);
    }
    return error;
  }

  // Checks if any of the checkboxes has been checked.
  const [...keys] = options.keys();
  const someChecked = keys.some((value) => Object.values(props.values[key] || {})?.includes(value));

  return (
    <div className={wrapperClassNames}>
      <Checkboxes
        {...fieldProps}
        className={elementClassNames}
        title={title}
        required={required}
        description={description}
        placeholder={placeholder}
        fieldName={key}
        validation={validation}
        touched={props.touched[key]}
        error={props.errors[key]}
        value={props.values[key]}
        options={options.toJS()}
        descriptions={descriptions.toJS()}
        otherLabel={otherLabel}
        otherPlaceholder={otherPlaceholder}
        correctAnswers={correctAnswers}
        someChecked={someChecked}
      />

      {someChecked && (
        <div className="explanation">
          <div className="title">
            <h3>{t('titles.explanation')}</h3>
          </div>

          <div className="body">
            <WysiwygField
              property="schema:text"
              html={explanation}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default QuizCheckboxes;
